(() => {
  'use strict';

  window.LDPDPModules = window.LDPDPModules || {};

  const parseVariants = (root) => {
    try {
      return JSON.parse(root.querySelector('[data-ld-engine-variants]')?.textContent || '[]');
    } catch (error) {
      console.error('LD PDP: dati variante non validi', error);
      return [];
    }
  };

  const parseSnapshot = (root) => {
    const node = root.querySelector('[data-ld-product-snapshot]');
    if (!node) return { node: null, data: null };

    try {
      return { node, data: JSON.parse(node.textContent || '{}') };
    } catch (error) {
      console.error('LD PDP: snapshot prodotto non valido', error);
      return { node, data: null };
    }
  };

  const parseUnitPrices = (root) => {
    try {
      return JSON.parse(root.querySelector('[data-ld-product-unit-prices]')?.textContent || '{}');
    } catch (error) {
      console.error('LD PDP: prezzi unitari non validi', error);
      return {};
    }
  };

  const mountProductForm = (root) => {
    const controller = new AbortController();
    const { signal } = controller;
    const unitPrices = parseUnitPrices(root);
    const variants = parseVariants(root).map((variant) => ({
      ...variant,
      hasUnitPrice: Boolean(unitPrices[String(variant.id)]?.hasUnitPrice),
      unitPriceFormatted: unitPrices[String(variant.id)]?.unitPriceFormatted || ''
    }));
    const snapshot = parseSnapshot(root);
    const optionSelects = Array.from(root.querySelectorAll('[data-ld-engine-option]'));
    const variantIdInput = root.querySelector('[data-ld-engine-variant-id]');
    const submitButton = root.querySelector('[data-testid="ld-experience-add-to-cart"]');
    const submitLabel = submitButton?.querySelector('.add-to-cart-text__content > span > span');
    const buyNowButton = root.querySelector('[data-ld-engine-buy-now]');
    const buyNowLabel = root.querySelector('[data-ld-engine-buy-now-text]');
    const addToCartComponent = submitButton?.closest('add-to-cart-component');
    const formElement = root.querySelector('form[data-type="add-to-cart-form"]');
    const liveRegion = root.querySelector('[ref="liveRegion"]');
    const quantitySelector = root.querySelector('quantity-selector-component');
    const quantityInput = quantitySelector?.querySelector('[ref="quantityInput"]');
    const priceCurrent = root.querySelector('[data-ld-engine-price-current]');
    const priceCompare = root.querySelector('[data-ld-engine-price-compare]');
    const unitPrice = root.querySelector('[data-ld-engine-unit-price]');
    const unitPriceValue = root.querySelector('[data-ld-engine-unit-price-value]');
    const availability = root.querySelector('[data-ld-engine-availability]');
    const availabilityText = root.querySelector('[data-ld-engine-availability-text]');
    const primaryMediaItem = root.querySelector('[data-ld-engine-phase-media][data-phase="0"]');
    const frontImage = primaryMediaItem?.querySelector('.ld-engine-stage__image');
    const mediaThumbs = Array.from(root.querySelectorAll('[data-ld-engine-media-thumb]'));
    const stickyPrice = root.querySelector('[data-ld-engine-sticky-price]');
    const stickyVariant = root.querySelector('[data-ld-engine-sticky-variant]');
    const stickySubmit = root.querySelector('[data-ld-engine-sticky-submit]');
    const mobileBar = root.querySelector('[data-ld-engine-mobile-bar]');
    const buybox = root.querySelector('.ld-pdp-engine__buybox');
    const purchaseAnchor = submitButton || formElement || buybox;
    const installmentAmount = root.querySelector('.ld-engine-installments .ld-installments-note__amount');
    const originalFront = frontImage?.currentSrc || frontImage?.src || '';
    const originalAlt = frontImage?.alt || '';
    const currency = document.documentElement.dataset.currency || window.Shopify?.currency?.active || 'EUR';
    const locale = document.documentElement.lang || 'it-IT';
    const money = new Intl.NumberFormat(locale, { style: 'currency', currency });
    const cartAddUrl = root.dataset.cartAddUrl || '/cart/add.js';
    const checkoutUrl = root.dataset.checkoutUrl || '/checkout';
    let selectedVariant = variants.find((variant) => String(variant.id) === String(variantIdInput?.value)) || variants[0] || null;
    let buyboxVisible = true;
    let checkoutPending = false;

    const updateProductSnapshot = (variant) => {
      if (!snapshot.node || !snapshot.data) return;

      snapshot.data.variant = variant ? {
        id: variant.id,
        title: variant.title,
        options: variant.options,
        price: variant.price,
        priceFormatted: variant.priceFormatted,
        compareAtPrice: variant.compareAtPrice || 0,
        compareAtPriceFormatted: variant.compareAtPriceFormatted || '',
        hasUnitPrice: Boolean(variant.hasUnitPrice),
        unitPriceFormatted: variant.unitPriceFormatted || '',
        available: Boolean(variant.available),
        url: variant.url || '',
        mediaId: variant.mediaId ?? null,
        image: variant.image || originalFront || null,
        imageAlt: variant.imageAlt || originalAlt || ''
      } : null;

      snapshot.node.textContent = JSON.stringify(snapshot.data);
    };

    const findSelectedVariant = () => {
      if (!optionSelects.length) return variants[0] || null;
      const selectedOptions = optionSelects.map((select) => select.value);
      return variants.find((variant) => variant.options.every((value, index) => value === selectedOptions[index])) || null;
    };

    const setButtonState = (available) => {
      if (submitButton) submitButton.disabled = !available;
      if (buyNowButton) buyNowButton.disabled = !available || checkoutPending;
      if (stickySubmit) {
        stickySubmit.disabled = !available;
        stickySubmit.textContent = available ? 'Aggiungi al carrello' : 'Esaurito';
      }
      if (submitLabel) submitLabel.textContent = available ? 'Aggiungi al carrello' : 'Esaurito';
      if (buyNowLabel && !checkoutPending) buyNowLabel.textContent = available ? 'Compra ora' : 'Esaurito';
      if (typeof addToCartComponent?.enable === 'function' && available) addToCartComponent.enable();
      if (typeof addToCartComponent?.disable === 'function' && !available) addToCartComponent.disable();
    };

    const setCheckoutBusy = (busy) => {
      checkoutPending = busy;
      if (buyNowButton) {
        buyNowButton.disabled = busy || !selectedVariant?.available;
        buyNowButton.setAttribute('aria-busy', String(busy));
      }
      if (buyNowLabel) buyNowLabel.textContent = busy ? 'Apertura checkout…' : selectedVariant?.available ? 'Compra ora' : 'Esaurito';
    };

    const updateQuantity = (variant) => {
      if (!quantityInput || !quantitySelector) return;
      const minimum = String(variant?.quantityMin || 1);
      const maximum = variant?.quantityMax == null ? null : String(variant.quantityMax);
      const increment = String(variant?.quantityIncrement || 1);

      if (variant) quantitySelector.dataset.variantId = String(variant.id);
      quantityInput.disabled = !variant?.available;
      if (typeof quantitySelector.updateConstraints === 'function') {
        quantitySelector.updateConstraints(minimum, maximum, increment);
      } else {
        quantityInput.min = minimum;
        quantityInput.step = increment;
        if (maximum) quantityInput.max = maximum;
        else quantityInput.removeAttribute('max');
        if (Number(quantityInput.value) < Number(minimum)) quantityInput.value = minimum;
      }
    };

    const markActiveMediaPhase = (phase) => {
      if (!mediaThumbs.length) return;
      const requestedPhase = Number(phase);
      mediaThumbs.forEach((thumb) => {
        const active = Number(thumb.dataset.mediaPhase) === requestedPhase;
        thumb.classList.toggle('is-active', active);
        if (active) thumb.setAttribute('aria-current', 'true');
        else thumb.removeAttribute('aria-current');
      });
    };

    const updatePrimaryMedia = (url, alt = '', mediaId = null) => {
      if (!frontImage || !url) return;
      frontImage.removeAttribute('srcset');
      frontImage.removeAttribute('sizes');
      frontImage.src = url;
      frontImage.alt = alt || originalAlt;
      primaryMediaItem?.setAttribute('data-media-id', mediaId || '');
      addToCartComponent?.setAttribute('data-product-variant-media', url);

      const primaryThumb = mediaThumbs.find((thumb) => Number(thumb.dataset.mediaPhase) === 0);
      if (primaryThumb) {
        primaryThumb.dataset.mediaId = mediaId || '';
        primaryThumb.dataset.mediaUrl = url;
        primaryThumb.dataset.mediaAlt = alt || originalAlt;
        const primaryThumbImage = primaryThumb.querySelector('img');
        if (primaryThumbImage) {
          primaryThumbImage.removeAttribute('srcset');
          primaryThumbImage.removeAttribute('sizes');
          primaryThumbImage.src = url;
          primaryThumbImage.alt = alt || originalAlt;
        }
      }

      if (Number(root.dataset.activeMediaPhase || 0) === 0) markActiveMediaPhase(0);
    };

    const showGalleryMedia = (thumb) => {
      const url = thumb?.dataset.mediaUrl;
      if (!frontImage || !url) return;
      frontImage.removeAttribute('srcset');
      frontImage.removeAttribute('sizes');
      frontImage.src = url;
      frontImage.alt = thumb.dataset.mediaAlt || originalAlt;
      primaryMediaItem?.setAttribute('data-media-id', thumb.dataset.mediaId || '');
      const phase = Number(thumb.dataset.mediaPhase || 0);
      root.dataset.activeMediaPhase = String(phase);
      markActiveMediaPhase(phase);
    };

    const updateVariant = (variant, updateUrl = true) => {
      selectedVariant = variant;

      if (!variant) {
        if (variantIdInput) variantIdInput.value = '';
        availability?.classList.add('is-unavailable');
        if (availabilityText) availabilityText.textContent = 'Non disponibile';
        if (unitPrice) unitPrice.hidden = true;
        if (unitPriceValue) unitPriceValue.textContent = '';
        setButtonState(false);
        updateQuantity(null);
        updateProductSnapshot(null);
        return;
      }

      if (variantIdInput) variantIdInput.value = String(variant.id);
      if (priceCurrent) priceCurrent.textContent = variant.priceFormatted;
      if (stickyPrice) stickyPrice.textContent = variant.priceFormatted;
      if (stickyVariant) stickyVariant.textContent = variant.title === 'Default Title' ? '' : variant.title;

      if (priceCompare) {
        priceCompare.textContent = variant.compareAtPriceFormatted || '';
        priceCompare.classList.toggle('is-hidden', !variant.compareAtPriceFormatted);
      }

      if (unitPrice) unitPrice.hidden = !variant.hasUnitPrice;
      if (unitPriceValue) unitPriceValue.textContent = variant.hasUnitPrice ? variant.unitPriceFormatted : '';

      availability?.classList.toggle('is-unavailable', !variant.available);
      if (availabilityText) availabilityText.textContent = variant.available ? 'Disponibile' : 'Esaurito';
      setButtonState(Boolean(variant.available));
      updateQuantity(variant);

      const mediaUrl = variant.image || originalFront;
      const mediaAlt = variant.imageAlt || originalAlt;
      if (frontImage && mediaUrl && frontImage.src !== mediaUrl) {
        updatePrimaryMedia(mediaUrl, mediaAlt, variant.mediaId);
      }

      if (installmentAmount) {
        installmentAmount.textContent = `3 rate da ${money.format(variant.price / 100 / 3)}`;
      }

      if (updateUrl && window.history?.replaceState) {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', String(variant.id));
        window.history.replaceState({}, '', url.toString());
      }

      root.dataset.activeVariant = String(variant.id);
      updateProductSnapshot(variant);
      root.dispatchEvent(new CustomEvent('ld:pdp:variant-change', { bubbles: true, detail: { variant } }));
    };

    const goToCheckout = async () => {
      if (!selectedVariant?.available || !formElement || checkoutPending) return;
      setCheckoutBusy(true);
      if (liveRegion) liveRegion.textContent = '';

      try {
        const formData = new FormData(formElement);
        formData.set('id', String(selectedVariant.id));
        if (!formData.get('quantity')) formData.set('quantity', '1');

        const response = await fetch(cartAddUrl, {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: formData
        });

        if (!response.ok) {
          let message = 'Impossibile procedere al checkout.';
          try {
            const data = await response.json();
            message = data.description || data.message || message;
          } catch (_) {
            // Mantiene un messaggio leggibile se Shopify risponde senza JSON.
          }
          throw new Error(message);
        }

        window.location.assign(checkoutUrl);
      } catch (error) {
        console.error('LD PDP: checkout diretto non disponibile', error);
        if (liveRegion) liveRegion.textContent = error.message || 'Impossibile procedere al checkout.';
        setCheckoutBusy(false);
      }
    };

    const addSelectedVariantToCart = () => {
      if (!selectedVariant?.available || !submitButton || submitButton.disabled) return;
      submitButton.click();
    };

    const restoreVariantFromUrl = () => {
      const variantId = new URL(window.location.href).searchParams.get('variant');
      if (!variantId) return;
      const variant = variants.find((candidate) => String(candidate.id) === variantId);
      if (!variant) return;

      variant.options.forEach((value, index) => {
        if (optionSelects[index]) optionSelects[index].value = value;
      });
      updateVariant(variant, false);
    };

    optionSelects.forEach((select) => {
      select.addEventListener('change', () => updateVariant(findSelectedVariant()), { signal });
    });

    formElement?.addEventListener('submit', () => {
      if (!selectedVariant || !variantIdInput) return;
      variantIdInput.value = String(selectedVariant.id);
    }, { capture: true, signal });

    mediaThumbs.forEach((thumb) => {
      thumb.addEventListener('click', (event) => {
        event.preventDefault();
        showGalleryMedia(thumb);
      }, { signal });
    });

    buyNowButton?.addEventListener('click', goToCheckout, { signal });
    stickySubmit?.addEventListener('click', addSelectedVariantToCart, { signal });
    window.addEventListener('popstate', restoreVariantFromUrl, { signal });

    const updateMobileBar = () => {
      if (!mobileBar) return;
      const rootRect = root.getBoundingClientRect();
      const insideExperience = rootRect.top < window.innerHeight * 0.7 && rootRect.bottom > 90;
      mobileBar.classList.toggle('is-visible', insideExperience && !buyboxVisible);
    };

    if ('IntersectionObserver' in window && purchaseAnchor) {
      const observer = new IntersectionObserver((entries) => {
        buyboxVisible = entries[0]?.isIntersecting ?? true;
        updateMobileBar();
      }, { threshold: 0.12 });
      observer.observe(purchaseAnchor);
      signal.addEventListener('abort', () => observer.disconnect(), { once: true });
    }

    window.addEventListener('scroll', updateMobileBar, { passive: true, signal });
    window.addEventListener('resize', updateMobileBar, { passive: true, signal });
    updateVariant(selectedVariant, false);
    updateMobileBar();

    return {
      updateVariant,
      get variant() {
        return selectedVariant;
      },
      destroy() {
        controller.abort();
        mobileBar?.classList.remove('is-visible');
      }
    };
  };

  window.LDPDPModules.mountProductForm = mountProductForm;
})();
